import CrunchClassManager from './react/CrunchClassManager';

window.CrunchClassManager = CrunchClassManager;

export default CrunchClassManager;
